import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ApiMethods from "../../../../ApiManager/ApiMethods";
import Avatar from "@mui/material/Avatar";
import { TextField, InputAdornment, Paper } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SideBarTest from "./SideBarTest"; // Import the SideBarTest component
import CustomSearchInput from "./CustomSearchBar";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";

const SideBarClients = ({
  close,
  handleToggleSidebar,
  setClientActive,
  setActiveClientInformation,
  activeClientInformation,
  openPopup,
  syncContacts,
  openSidebarClient,
  openPopupState,
  setOpenSidebarClient,
}) => {
  const [clients, setClients] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [isSidebarTestOpen, setIsSidebarTestOpen] = useState(false);

  useEffect(() => {
    fetchClients();
  }, [activeClientInformation, syncContacts]);

  const fetchClients = async () => {
    try {
      const response = await ApiMethods.get("client");
      console.log(response, "response");
      // A failed/unauthenticated request can resolve with a non-array body (or nothing) instead
      // of throwing — `clients` staying an array is what keeps `filteredClients` below from
      // crashing the whole app with "clients.filter is not a function".
      setClients(Array.isArray(response) ? response : []);
    } catch (err) {
      console.log(err);
      setClients([]);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleClientClick = (client) => {
    console.log("ovo je klijentttt", client);
    setClientActive(client.id);
    setActiveClientInformation(client);
    setOpenSidebarClient();
  };

  const filteredClients = clients.filter((client) => {
    const firstName = client.first_name ? client.first_name.toLowerCase() : "";
    const lastName = client.last_name ? client.last_name.toLowerCase() : "";

    return (
      firstName.includes(searchQuery.toLowerCase().trim()) ||
      lastName.includes(searchQuery.toLowerCase().trim())
    );
  });

  if (isSidebarTestOpen && selectedClientId) {
    return (
      <SideBarTest
        isOpen={isSidebarTestOpen}
        toggleSidebar={handleToggleSidebar}
        client_id={selectedClientId}
        closeSearch={() => setIsSidebarTestOpen(false)}
      />
    );
  }

  return (
    <div
      style={{
        padding: "0px",
      }}
      className={
        openSidebarClient
          ? "drawer-main-container drawer-open"
          : "drawer-main-container drawer-open  not-opened"
      }
    >
      <div className="sidebar-client-search">
        <CustomSearchInput value={searchQuery} onChange={handleSearchChange} />
        <div className="sidebar-menu" onClick={setOpenSidebarClient}>
          <img src="Vector.png" />
        </div>
      </div>

      <div
        style={{
          height: "100%",
          paddingBottom: "140px",
        }}
      >
        <div
          style={{
            height: "100%",
            overflow: "scroll",
            padding: "0px 15px",
            scrollbarWidth: "none",
          }}
        >
          {filteredClients.map((client, index) => (
            <div
              className="sidebar-client-part"
              key={index}
              onClick={() => handleClientClick(client)}
            >
              <div className="name-sidebar-part">
                <Avatar
                  sx={{
                    width: 24,
                    height: 24,
                    marginRight: "5px",
                    backgroundColor:
                      client.gender == "No"
                        ? "#adb5bd"
                        : client.gender === "Male"
                        ? "#97dfff"
                        : "#FF8E8B",
                    border: "none",
                    color: "black",
                    borderRadius: "50%",
                    fontSize: "8px",
                    fontWeight: "600",
                  }}
                >
                  {client.first_name ? client.first_name[0].toUpperCase() : "?"}
                  {client.last_name ? client.last_name[0].toUpperCase() : "?"}
                </Avatar>

                <div className="sidebar-name-card">
                  {client.first_name} {client.last_name}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SideBarClients;
